export var DashBoardDataEnum;
(function (DashBoardDataEnum) {
    DashBoardDataEnum["Name"] = "Name";
    DashBoardDataEnum["CreatedTime"] = "CreatedTime";
    DashBoardDataEnum["TxRecordId"] = "TxRecordId";
    DashBoardDataEnum["Amount"] = "Amount";
})(DashBoardDataEnum || (DashBoardDataEnum = {}));
export var DashBoardDataColumns = [
    {
        label: "Name",
        apiKey: DashBoardDataEnum.Name,
        hasSort: true,
        colDataType: "string",
    },
    {
        label: "Date and Time (EST)",
        apiKey: DashBoardDataEnum.CreatedTime,
        hasSort: true,
        colDataType: "date",
    },
    {
        label: "Transaction#",
        apiKey: DashBoardDataEnum.TxRecordId,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Amount",
        apiKey: DashBoardDataEnum.Amount,
        hasSort: true,
        colDataType: "number",
    },
];
export var UserMangementDataEnum;
(function (UserMangementDataEnum) {
    UserMangementDataEnum["Name"] = "FirstName";
    UserMangementDataEnum["Role"] = "RoleType";
    UserMangementDataEnum["EmailAddress"] = "Email";
    UserMangementDataEnum["PortalName"] = "PortalName";
    UserMangementDataEnum["CreatedTime"] = "CreatedTime";
    UserMangementDataEnum["Status"] = "userStatus";
})(UserMangementDataEnum || (UserMangementDataEnum = {}));
export var AdminMangementDataEnum;
(function (AdminMangementDataEnum) {
    AdminMangementDataEnum["Name"] = "FirstName";
    AdminMangementDataEnum["Role"] = "RoleDescription";
    AdminMangementDataEnum["EmailAddress"] = "Email";
    AdminMangementDataEnum["CreatedTime"] = "CreatedTime";
    AdminMangementDataEnum["Status"] = "AdminStatus";
})(AdminMangementDataEnum || (AdminMangementDataEnum = {}));
export var DealerProgramAssociation;
(function (DealerProgramAssociation) {
    DealerProgramAssociation["DealerName"] = "DealerName";
    DealerProgramAssociation["DealerOID"] = "DealerAccountAspireOId";
    DealerProgramAssociation["DealerID"] = "DealerAccountAspireId";
    DealerProgramAssociation["Programs"] = "ProgramNames";
})(DealerProgramAssociation || (DealerProgramAssociation = {}));
export var ResubmitApplicationDataEnum;
(function (ResubmitApplicationDataEnum) {
    ResubmitApplicationDataEnum["ApplicationId"] = "ApplicationId";
    ResubmitApplicationDataEnum["Name"] = "CustomerName";
    ResubmitApplicationDataEnum["PortalName"] = "PortalName";
    ResubmitApplicationDataEnum["SalesRepName"] = "SalesRepName";
    ResubmitApplicationDataEnum["DateAndTime"] = "CreatedTime";
    ResubmitApplicationDataEnum["ErrorMessage"] = "SyncErrorLog";
    ResubmitApplicationDataEnum["Status"] = "SyncStatus";
})(ResubmitApplicationDataEnum || (ResubmitApplicationDataEnum = {}));
export var DealerMangementDataEnum;
(function (DealerMangementDataEnum) {
    DealerMangementDataEnum["Name"] = "Name";
    DealerMangementDataEnum["PortalName"] = "Domain";
    DealerMangementDataEnum["CreatedTime"] = "CreatedTime";
})(DealerMangementDataEnum || (DealerMangementDataEnum = {}));
export var MarketingContentEnum;
(function (MarketingContentEnum) {
    MarketingContentEnum["Portal"] = "Portal";
    MarketingContentEnum["NotificationMessage"] = "Message";
    MarketingContentEnum["FromDate"] = "FromDate";
    MarketingContentEnum["FromTime"] = "FromTime";
    MarketingContentEnum["ToDate"] = "ToDate";
    MarketingContentEnum["ToTime"] = "ToTime";
    MarketingContentEnum["Status"] = "Status";
})(MarketingContentEnum || (MarketingContentEnum = {}));
export var ProgramManagementEnum;
(function (ProgramManagementEnum) {
    ProgramManagementEnum["ProgramName"] = "Name";
    ProgramManagementEnum["CompanyID"] = "FinanceCompanyRecordId";
    ProgramManagementEnum["Country"] = "Country";
    ProgramManagementEnum["PrivateLabel"] = "PrivateLabel";
})(ProgramManagementEnum || (ProgramManagementEnum = {}));
export var ApplicationManagementEnum;
(function (ApplicationManagementEnum) {
    ApplicationManagementEnum["Name"] = "Name";
    ApplicationManagementEnum["TxAspireOId"] = "TxAspireOId";
    ApplicationManagementEnum["ContractID"] = "ContractAspireId";
    ApplicationManagementEnum["Amount"] = "Amount";
    ApplicationManagementEnum["Status"] = "AspireStatus";
    ApplicationManagementEnum["CreatedTime"] = "CreatedTime";
    ApplicationManagementEnum["ApplicationType"] = "ApplicationType";
    ApplicationManagementEnum["PortalType"] = "PortalType";
    ApplicationManagementEnum["LastModifiedTime"] = "LastModifiedTime";
    ApplicationManagementEnum["ForecastDate"] = "ForecastDate";
})(ApplicationManagementEnum || (ApplicationManagementEnum = {}));
export var AppFinancingAndAdjustmentsEnum;
(function (AppFinancingAndAdjustmentsEnum) {
    AppFinancingAndAdjustmentsEnum["Category"] = "Category";
    AppFinancingAndAdjustmentsEnum["Description"] = "Description";
    AppFinancingAndAdjustmentsEnum["EffectiveDate"] = "EffectiveDate";
    AppFinancingAndAdjustmentsEnum["Quantity"] = "Quantity";
    AppFinancingAndAdjustmentsEnum["UnitAmount"] = "UnitAmount";
})(AppFinancingAndAdjustmentsEnum || (AppFinancingAndAdjustmentsEnum = {}));
export var AppDocumentsManagementEnum;
(function (AppDocumentsManagementEnum) {
    AppDocumentsManagementEnum["FileName"] = "FileName";
    AppDocumentsManagementEnum["FileSize"] = "FileSize";
    AppDocumentsManagementEnum["DocumentType"] = "DocumentType";
    AppDocumentsManagementEnum["CreatedDate"] = "CreatedDate";
    AppDocumentsManagementEnum["LastChangeOperator"] = "LastChangeOperator";
    AppDocumentsManagementEnum["LastChangeDateTime"] = "LastChangeDateTime";
})(AppDocumentsManagementEnum || (AppDocumentsManagementEnum = {}));
export var BacklogPaymentStreamEnum;
(function (BacklogPaymentStreamEnum) {
    BacklogPaymentStreamEnum["FirstPaymentDate"] = "FirstPaymentDate";
    BacklogPaymentStreamEnum["Frequency"] = "Frequency";
    BacklogPaymentStreamEnum["NumOfPayments"] = "NumOfPayments";
    BacklogPaymentStreamEnum["PaymentType"] = "PaymentType";
    BacklogPaymentStreamEnum["Amount"] = "Amount";
    BacklogPaymentStreamEnum["TotalAmount"] = "TotalAmount";
    BacklogPaymentStreamEnum["IsInvoiced"] = "IsInvoiced";
    BacklogPaymentStreamEnum["IsAdvance"] = "IsAdvance";
})(BacklogPaymentStreamEnum || (BacklogPaymentStreamEnum = {}));
export var AccPayableInvoiceEnum;
(function (AccPayableInvoiceEnum) {
    AccPayableInvoiceEnum["InvoiceNumber"] = "InvoiceNumber";
    AccPayableInvoiceEnum["Description"] = "Description";
    AccPayableInvoiceEnum["ItemType"] = "ItemType";
    AccPayableInvoiceEnum["Amount"] = "Amount";
    AccPayableInvoiceEnum["DistributionAccount"] = "DistributionAccount";
    AccPayableInvoiceEnum["EquipmentDescription"] = "EquipmentDescription";
    AccPayableInvoiceEnum["OriginalCost"] = "OriginalCost";
    AccPayableInvoiceEnum["AssetOrCollateralId"] = "AssetOrCollateralId";
    AccPayableInvoiceEnum["SerialNums"] = "SerialNums";
})(AccPayableInvoiceEnum || (AccPayableInvoiceEnum = {}));
export var AccPayableContractItemsEnum;
(function (AccPayableContractItemsEnum) {
    AccPayableContractItemsEnum["Description"] = "Description";
    AccPayableContractItemsEnum["AssetOrCollateralId"] = "AssetOrCollateralId";
    AccPayableContractItemsEnum["InvoiceNumber"] = "InvoiceNumber";
    AccPayableContractItemsEnum["Quantity"] = "Quantity";
    AccPayableContractItemsEnum["SerialNums"] = "SerialNums";
    AccPayableContractItemsEnum["Vendor"] = "Vendor";
    AccPayableContractItemsEnum["Manufacturer"] = "Manufacturer";
    AccPayableContractItemsEnum["Machine"] = "Machine";
    AccPayableContractItemsEnum["Model"] = "Model";
    AccPayableContractItemsEnum["ModelYear"] = "ModelYear";
    AccPayableContractItemsEnum["TypeDescription"] = "TypeDescription";
    AccPayableContractItemsEnum["PartNumber"] = "PartNumber";
    AccPayableContractItemsEnum["StockNumber"] = "StockNumber";
    AccPayableContractItemsEnum["TitleNumber"] = "TitleNumber";
    AccPayableContractItemsEnum["ItemType"] = "ItemType";
    AccPayableContractItemsEnum["Amount"] = "Amount";
    AccPayableContractItemsEnum["OriginalCost"] = "OriginalCost";
    AccPayableContractItemsEnum["PurchaseDate"] = "PurchaseDate";
    AccPayableContractItemsEnum["UnitAmount"] = "UnitAmount";
    AccPayableContractItemsEnum["Location"] = "Location";
    AccPayableContractItemsEnum["LicenseId"] = "LicenseId";
    AccPayableContractItemsEnum["LicenseState"] = "LicenseState";
    AccPayableContractItemsEnum["Installation"] = "Installation";
    AccPayableContractItemsEnum["Status"] = "Status";
})(AccPayableContractItemsEnum || (AccPayableContractItemsEnum = {}));
export var UserMangementCols = [
    {
        label: "Name",
        apiKey: UserMangementDataEnum.Name,
        hasSort: true,
        colDataType: "string",
    },
    {
        label: "Role",
        apiKey: UserMangementDataEnum.Role,
        hasSort: true,
        colDataType: "string",
    },
    {
        label: "Email Address",
        apiKey: UserMangementDataEnum.EmailAddress,
        hasSort: true,
        colDataType: "string",
    },
    {
        label: "Portal Name",
        apiKey: UserMangementDataEnum.PortalName,
        hasSort: true,
        colDataType: "string",
    },
    {
        label: "Created Date",
        apiKey: UserMangementDataEnum.CreatedTime,
        hasSort: true,
        colDataType: "date",
    },
    {
        label: "Status",
        apiKey: UserMangementDataEnum.Status,
        hasSort: true,
        colDataType: "string",
    },
];
export var CustomerPortalUserManagementDataEnum;
(function (CustomerPortalUserManagementDataEnum) {
    CustomerPortalUserManagementDataEnum["Name"] = "Name";
    CustomerPortalUserManagementDataEnum["Email"] = "Email";
    CustomerPortalUserManagementDataEnum["AspireId"] = "AspireId";
    CustomerPortalUserManagementDataEnum["CreatedTime"] = "CreatedTime";
    CustomerPortalUserManagementDataEnum["Status"] = "Status";
})(CustomerPortalUserManagementDataEnum || (CustomerPortalUserManagementDataEnum = {}));
export var CustomerPortalUserNotificationDataEnum;
(function (CustomerPortalUserNotificationDataEnum) {
    CustomerPortalUserNotificationDataEnum["TimeStamp"] = "createdDate";
    CustomerPortalUserNotificationDataEnum["EmailNotification"] = "message";
})(CustomerPortalUserNotificationDataEnum || (CustomerPortalUserNotificationDataEnum = {}));
export var CustomerPortalUserNotificationCols = [
    {
        label: "TimeStamp",
        apiKey: CustomerPortalUserNotificationDataEnum.TimeStamp,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Notification Message",
        apiKey: CustomerPortalUserNotificationDataEnum.EmailNotification,
        hasSort: false,
        colDataType: "string",
        tooltipConfig: {
            bgColor: "#333333",
            textColor: "#ffffff",
            fontSize: "13px",
            padding: "10px 12px",
            borderRadius: "6px",
            arrowColor: "#333333",
        },
    },
];
export var CustomerPortalUserManagementCols = [
    {
        label: "Name",
        apiKey: CustomerPortalUserManagementDataEnum.Name,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Email / Phone Number",
        apiKey: CustomerPortalUserManagementDataEnum.Email,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Customer ID",
        apiKey: CustomerPortalUserManagementDataEnum.AspireId,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Registered On",
        apiKey: CustomerPortalUserManagementDataEnum.CreatedTime,
        hasSort: true,
        colDataType: "date",
    },
    {
        label: "Status",
        apiKey: CustomerPortalUserManagementDataEnum.Status,
        hasSort: false,
        colDataType: "string",
    },
];
export var CustomerPortalRegistrationManagementDataEnum;
(function (CustomerPortalRegistrationManagementDataEnum) {
    CustomerPortalRegistrationManagementDataEnum["Name"] = "RegistrationName";
    CustomerPortalRegistrationManagementDataEnum["Email"] = "RegistrationEmail";
    CustomerPortalRegistrationManagementDataEnum["RegistrationStatus"] = "RegistrationStatus";
    CustomerPortalRegistrationManagementDataEnum["CreatedTime"] = "RegistrationCreatedOn";
    CustomerPortalRegistrationManagementDataEnum["LinkExpiry"] = "RegistrationLinkExpiry";
    CustomerPortalRegistrationManagementDataEnum["Portal"] = "RegistrationPortal";
})(CustomerPortalRegistrationManagementDataEnum || (CustomerPortalRegistrationManagementDataEnum = {}));
export var CustomerPortalRegistrationManagementCols = [
    {
        label: "Name",
        apiKey: CustomerPortalRegistrationManagementDataEnum.Name,
        hasSort: false,
        colDataType: "string",
        width: 150,
    },
    {
        label: "Email",
        apiKey: CustomerPortalRegistrationManagementDataEnum.Email,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Portal",
        apiKey: CustomerPortalRegistrationManagementDataEnum.Portal,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Status",
        apiKey: CustomerPortalRegistrationManagementDataEnum.RegistrationStatus,
        hasSort: false,
        colDataType: "string",
        tooltipConfig: {
            bgColor: "#333333",
            textColor: "#ffffff",
            fontSize: "13px",
            padding: "10px 12px",
            borderRadius: "6px",
            arrowColor: "#333333",
        },
    },
    {
        label: "Created On",
        apiKey: CustomerPortalRegistrationManagementDataEnum.CreatedTime,
        hasSort: true,
        colDataType: "date",
    },
    {
        label: "Link Expiry",
        apiKey: CustomerPortalRegistrationManagementDataEnum.LinkExpiry,
        hasSort: false,
        colDataType: "date",
    },
];
export var AdminRegisteredUsersDataEnum;
(function (AdminRegisteredUsersDataEnum) {
    AdminRegisteredUsersDataEnum["Email"] = "Email";
    AdminRegisteredUsersDataEnum["Name"] = "Name";
    AdminRegisteredUsersDataEnum["Contract"] = "RegisteredContract";
    AdminRegisteredUsersDataEnum["Status"] = "Status";
    AdminRegisteredUsersDataEnum["ExpiresAt"] = "ExpiresAt";
})(AdminRegisteredUsersDataEnum || (AdminRegisteredUsersDataEnum = {}));
export var AdminRegisteredUsersCols = [
    {
        label: "Email",
        apiKey: AdminRegisteredUsersDataEnum.Email,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Name",
        apiKey: AdminRegisteredUsersDataEnum.Name,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Contract",
        apiKey: AdminRegisteredUsersDataEnum.Contract,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Status",
        apiKey: AdminRegisteredUsersDataEnum.Status,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Expires At",
        apiKey: AdminRegisteredUsersDataEnum.ExpiresAt,
        hasSort: false,
        colDataType: "date",
    },
];
export var CustomerPortalPaymentManagementDataEnum;
(function (CustomerPortalPaymentManagementDataEnum) {
    CustomerPortalPaymentManagementDataEnum["Customer"] = "Customer";
    CustomerPortalPaymentManagementDataEnum["ContractId"] = "ContractId";
    CustomerPortalPaymentManagementDataEnum["Amount"] = "PaymentAmount";
    CustomerPortalPaymentManagementDataEnum["Date"] = "Date";
    CustomerPortalPaymentManagementDataEnum["Source"] = "Source";
    CustomerPortalPaymentManagementDataEnum["PortalName"] = "portalName";
    CustomerPortalPaymentManagementDataEnum["Status"] = "PaymentStatus";
    CustomerPortalPaymentManagementDataEnum["StripeTransactionId"] = "StripeTransactionId";
    CustomerPortalPaymentManagementDataEnum["Comments"] = "Comments";
    CustomerPortalPaymentManagementDataEnum["StripeStatus"] = "StripeStatus";
})(CustomerPortalPaymentManagementDataEnum || (CustomerPortalPaymentManagementDataEnum = {}));
export var CustomerPortalPaymentManagementCols = [
    {
        label: "Customer Name",
        apiKey: CustomerPortalPaymentManagementDataEnum.Customer,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Contract ID",
        apiKey: CustomerPortalPaymentManagementDataEnum.ContractId,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Portal Name",
        apiKey: CustomerPortalPaymentManagementDataEnum.PortalName,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Amount",
        apiKey: CustomerPortalPaymentManagementDataEnum.Amount,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Payment Scheduled Date",
        apiKey: CustomerPortalPaymentManagementDataEnum.Date,
        hasSort: true,
        colDataType: "date",
        width: "110px",
    },
    {
        label: "Payment Mode",
        apiKey: CustomerPortalPaymentManagementDataEnum.Source,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Aspire Status",
        apiKey: CustomerPortalPaymentManagementDataEnum.Status,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Transaction ID",
        apiKey: CustomerPortalPaymentManagementDataEnum.StripeTransactionId,
        hasSort: false,
        colDataType: "string",
        width: "180px",
    },
    {
        label: "Stripe Status",
        apiKey: CustomerPortalPaymentManagementDataEnum.StripeStatus,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Comments",
        apiKey: CustomerPortalPaymentManagementDataEnum.Comments,
        hasSort: false,
        colDataType: "string",
        width: "280px",
    },
];
export var AdminManagementCols = [
    {
        label: "Admin Name",
        apiKey: AdminMangementDataEnum.Name,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Role",
        apiKey: AdminMangementDataEnum.Role,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Email Address",
        apiKey: AdminMangementDataEnum.EmailAddress,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Created Date",
        apiKey: AdminMangementDataEnum.CreatedTime,
        hasSort: true,
        colDataType: "date",
    },
    {
        label: "Status",
        apiKey: AdminMangementDataEnum.Status,
        hasSort: false,
        colDataType: "string",
    },
];
export var RolesPermissionsCols = [
    {
        label: "Role Name",
        apiKey: "RoleName",
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Description",
        apiKey: "RoleDescription",
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Users Assigned",
        apiKey: "UserCount",
        hasSort: false,
        colDataType: "string",
    },
];
export var DealerProgramAssociationCols = [
    {
        label: "Dealer Name",
        apiKey: DealerProgramAssociation.DealerName,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Dealer ID",
        apiKey: DealerProgramAssociation.DealerID,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Dealer OID",
        apiKey: DealerProgramAssociation.DealerOID,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Programs",
        apiKey: DealerProgramAssociation.Programs,
        hasSort: false,
        colDataType: "string",
    },
];
export var DealerManagementCols = [
    {
        label: "Portal Name",
        apiKey: DealerMangementDataEnum.Name,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Portal URL",
        apiKey: DealerMangementDataEnum.PortalName,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Created Date",
        apiKey: DealerMangementDataEnum.CreatedTime,
        hasSort: true,
        colDataType: "date",
    },
];
export var SupportTicketDataEnum;
(function (SupportTicketDataEnum) {
    SupportTicketDataEnum["TicketId"] = "TicketCode";
    SupportTicketDataEnum["Description"] = "Description";
    SupportTicketDataEnum["RaisedBy"] = "TicketRaisedBy";
    SupportTicketDataEnum["CreatedTime"] = "CreatedTime";
    SupportTicketDataEnum["Status"] = "ticketStatus";
})(SupportTicketDataEnum || (SupportTicketDataEnum = {}));
export var CustomerPortalSupportManagementDataEnum;
(function (CustomerPortalSupportManagementDataEnum) {
    CustomerPortalSupportManagementDataEnum["TicketId"] = "ticketId";
    CustomerPortalSupportManagementDataEnum["Customer"] = "customer";
    CustomerPortalSupportManagementDataEnum["Subject"] = "subject";
    CustomerPortalSupportManagementDataEnum["Description"] = "description";
    CustomerPortalSupportManagementDataEnum["Date"] = "date";
    CustomerPortalSupportManagementDataEnum["Status"] = "status";
    CustomerPortalSupportManagementDataEnum["PortalName"] = "portalName";
})(CustomerPortalSupportManagementDataEnum || (CustomerPortalSupportManagementDataEnum = {}));
export var SupportTicketCols = [
    {
        label: "Ticket ID",
        apiKey: SupportTicketDataEnum.TicketId,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Issue Description",
        apiKey: SupportTicketDataEnum.Description,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Raised By",
        apiKey: SupportTicketDataEnum.RaisedBy,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Created Date",
        apiKey: SupportTicketDataEnum.CreatedTime,
        hasSort: true,
        colDataType: "date",
    },
    {
        label: "Status",
        apiKey: SupportTicketDataEnum.Status,
        hasSort: false,
        colDataType: "string",
    },
];
export var GenericMarketingTable = [
    {
        label: "Notification Message",
        apiKey: MarketingContentEnum.NotificationMessage,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "From Date",
        apiKey: MarketingContentEnum.FromDate,
        hasSort: false,
        colDataType: "date",
    },
    {
        label: "From Time",
        apiKey: MarketingContentEnum.FromTime,
        hasSort: false,
        colDataType: "date",
    },
    {
        label: "To Date",
        apiKey: MarketingContentEnum.ToDate,
        hasSort: false,
        colDataType: "date",
    },
    {
        label: "To Time",
        apiKey: MarketingContentEnum.ToTime,
        hasSort: false,
        colDataType: "date",
    },
    {
        label: "Status",
        apiKey: MarketingContentEnum.Status,
        hasSort: false,
        colDataType: "string",
    },
];
export var PortalMarketingTable = [
    {
        label: "Portal",
        apiKey: MarketingContentEnum.Portal,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Notification Message",
        apiKey: MarketingContentEnum.NotificationMessage,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "From Date",
        apiKey: MarketingContentEnum.FromDate,
        hasSort: false,
        colDataType: "date",
    },
    {
        label: "From Time",
        apiKey: MarketingContentEnum.FromTime,
        hasSort: false,
        colDataType: "date",
    },
    {
        label: "To Date",
        apiKey: MarketingContentEnum.ToDate,
        hasSort: false,
        colDataType: "date",
    },
    {
        label: "To Time",
        apiKey: MarketingContentEnum.ToTime,
        hasSort: false,
        colDataType: "date",
    },
    {
        label: "Status",
        apiKey: MarketingContentEnum.Status,
        hasSort: false,
        colDataType: "string",
    },
];
export var ProgramManagementTable = [
    {
        label: "Program Name",
        apiKey: ProgramManagementEnum.ProgramName,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Company ID",
        apiKey: ProgramManagementEnum.CompanyID,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Country",
        apiKey: ProgramManagementEnum.Country,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Private Label",
        apiKey: ProgramManagementEnum.PrivateLabel,
        hasSort: false,
        colDataType: "string",
    },
];
export var BackLogTable = [
    {
        label: "Customer Name",
        apiKey: ApplicationManagementEnum.Name,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Type",
        apiKey: ApplicationManagementEnum.ApplicationType,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Portal Type",
        apiKey: ApplicationManagementEnum.PortalType,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Transaction #",
        apiKey: ApplicationManagementEnum.TxAspireOId,
        hasSort: true,
        colDataType: "string",
    },
    {
        label: "Contract ID",
        apiKey: ApplicationManagementEnum.ContractID,
        hasSort: true,
        colDataType: "string",
    },
    {
        label: "Amount",
        apiKey: ApplicationManagementEnum.Amount,
        hasSort: false,
        colDataType: "number",
    },
    {
        label: "Submission Date",
        apiKey: ApplicationManagementEnum.CreatedTime,
        hasSort: false,
        colDataType: "date",
    },
    {
        label: "Status",
        apiKey: ApplicationManagementEnum.Status,
        hasSort: true,
        colDataType: "string",
    },
    {
        label: "Date & Time",
        apiKey: ApplicationManagementEnum.LastModifiedTime,
        hasSort: true,
        colDataType: "date",
    },
];
export var PaymentScheduleTable = [
    {
        label: "First Payment Date",
        apiKey: BacklogPaymentStreamEnum.FirstPaymentDate,
        hasSort: false,
        colDataType: "date",
    },
    {
        label: "Amount",
        apiKey: BacklogPaymentStreamEnum.Amount,
        hasSort: false,
        colDataType: "number",
    },
    {
        label: "Frequency",
        apiKey: BacklogPaymentStreamEnum.Frequency,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "No of Payments",
        apiKey: BacklogPaymentStreamEnum.NumOfPayments,
        hasSort: false,
        colDataType: "number",
    },
    {
        label: "Payment Type",
        apiKey: BacklogPaymentStreamEnum.PaymentType,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Total Amount",
        apiKey: BacklogPaymentStreamEnum.TotalAmount,
        hasSort: false,
        colDataType: "number",
    },
];
export var FinancingAndAdjustmentsTable = [
    {
        label: "Category",
        apiKey: AppFinancingAndAdjustmentsEnum.Category,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Description",
        apiKey: AppFinancingAndAdjustmentsEnum.Description,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Effective Date",
        apiKey: AppFinancingAndAdjustmentsEnum.EffectiveDate,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Quantity",
        apiKey: AppFinancingAndAdjustmentsEnum.Quantity,
        hasSort: false,
        colDataType: "number",
    },
    {
        label: "Unit Amount",
        apiKey: AppFinancingAndAdjustmentsEnum.UnitAmount,
        hasSort: false,
        colDataType: "string",
    },
];
export var DocumentsManagementTable = [
    {
        label: "File Name",
        apiKey: AppDocumentsManagementEnum.FileName,
        hasSort: true,
        colDataType: "string",
    },
    {
        label: "Size",
        apiKey: AppDocumentsManagementEnum.FileSize,
        hasSort: true,
        colDataType: "string",
    },
    {
        label: "Document Type",
        apiKey: AppDocumentsManagementEnum.DocumentType,
        hasSort: true,
        colDataType: "string",
    },
    {
        label: "Modified By",
        apiKey: AppDocumentsManagementEnum.LastChangeOperator,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Modified Date",
        apiKey: AppDocumentsManagementEnum.LastChangeDateTime,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Created Date",
        apiKey: AppDocumentsManagementEnum.CreatedDate,
        hasSort: false,
        colDataType: "string",
    },
];
export var AccountsPayableInvoiceDetailsTable = [
    {
        label: "Description",
        apiKey: AccPayableInvoiceEnum.Description,
        hasSort: false,
        colDataType: "date",
    },
    {
        label: "Item Type",
        apiKey: AccPayableInvoiceEnum.ItemType,
        hasSort: false,
        colDataType: "number",
    },
    {
        label: "Amount",
        apiKey: AccPayableInvoiceEnum.Amount,
        hasSort: false,
        colDataType: "number",
    },
    {
        label: "Distribution Account",
        apiKey: AccPayableInvoiceEnum.DistributionAccount,
        hasSort: false,
        colDataType: "number",
    },
    {
        label: "Equip Description",
        apiKey: AccPayableInvoiceEnum.EquipmentDescription,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Original Cost",
        apiKey: AccPayableInvoiceEnum.OriginalCost,
        hasSort: false,
        colDataType: "number",
    },
    {
        label: "Asset/Collateral #s",
        apiKey: AccPayableInvoiceEnum.AssetOrCollateralId,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Serial #s",
        apiKey: AccPayableInvoiceEnum.SerialNums,
        hasSort: false,
        colDataType: "string",
    },
];
export var AccountsPayableContractItemsTable = [
    {
        label: "On this Invoice",
        apiKey: AccPayableContractItemsEnum.InvoiceNumber,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Description",
        apiKey: AccPayableContractItemsEnum.Description,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Asset/Collateral #s",
        apiKey: AccPayableContractItemsEnum.AssetOrCollateralId,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Invoice #s",
        apiKey: AccPayableContractItemsEnum.InvoiceNumber,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Serial #s",
        apiKey: AccPayableContractItemsEnum.SerialNums,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Qty",
        apiKey: AccPayableContractItemsEnum.Quantity,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "TypeDescription",
        apiKey: AccPayableContractItemsEnum.TypeDescription,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Vendor",
        apiKey: AccPayableContractItemsEnum.Vendor,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Manufacturer",
        apiKey: AccPayableContractItemsEnum.Manufacturer,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Machine",
        apiKey: AccPayableContractItemsEnum.Machine,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Model",
        apiKey: AccPayableContractItemsEnum.Model,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "ModelYear",
        apiKey: AccPayableContractItemsEnum.ModelYear,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Part #",
        apiKey: AccPayableContractItemsEnum.PartNumber,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "SKU",
        apiKey: AccPayableContractItemsEnum.StockNumber,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Title #",
        apiKey: AccPayableContractItemsEnum.TitleNumber,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Purchase Date",
        apiKey: AccPayableContractItemsEnum.PurchaseDate,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Original Cost",
        apiKey: AccPayableContractItemsEnum.OriginalCost,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Unit Amount",
        apiKey: AccPayableContractItemsEnum.UnitAmount,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Location",
        apiKey: AccPayableContractItemsEnum.Location,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "License #",
        apiKey: AccPayableContractItemsEnum.LicenseId,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "License State",
        apiKey: AccPayableContractItemsEnum.LicenseState,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Installation",
        apiKey: AccPayableContractItemsEnum.Installation,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Status",
        apiKey: AccPayableContractItemsEnum.Status,
        hasSort: false,
        colDataType: "string",
    },
];
export var SCBPaymentScheduleTable = [
    {
        label: "First Payment Date",
        apiKey: BacklogPaymentStreamEnum.FirstPaymentDate,
        hasSort: false,
        colDataType: "date",
    },
    {
        label: "Amount",
        apiKey: BacklogPaymentStreamEnum.Amount,
        hasSort: false,
        colDataType: "number",
    },
    {
        label: "Frequency",
        apiKey: BacklogPaymentStreamEnum.Frequency,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "No of Payments",
        apiKey: BacklogPaymentStreamEnum.NumOfPayments,
        hasSort: false,
        colDataType: "number",
    },
    {
        label: "Payment Type",
        apiKey: BacklogPaymentStreamEnum.PaymentType,
        hasSort: false,
        colDataType: "string",
    },
    {
        label: "Total Amount",
        apiKey: BacklogPaymentStreamEnum.TotalAmount,
        hasSort: false,
        colDataType: "number",
    },
];
